import { TTranslationFunction } from '@/types'

import { THelpStep } from './HelpDialog'

export const stepDataListClone1 = (t: TTranslationFunction) =>
	[
		{
			title: t('generator__help_popup__step_1__title'),
			description: t('generator__help_popup__step_1__description'),
		},
		{
			title: t('generator__help_popup__step_2__title'),
			description: t('generator__help_popup__step_2__description'),
		},
		{
			title: t('generator__help_popup__step_3__title'),
			description: t('generator__help_popup__step_3__description'),
		},
		{
			title: t('generator__help_popup__step_4__title'),
			description: t('generator__help_popup__step_4__description'),
		},
		{
			title: t('generator__help_popup__step_5__title'),
			description: t('generator__help_popup__step_5__description'),
		},
	] satisfies Omit<THelpStep, 'imageUrlMobile' | 'imageUrlDesktop'>[]
